import Vue from "vue"

const REALTIME = "/news/realtime"
const TEST_REALTIME = `https://test-api.signal.bz${REALTIME}`

const get = async (url, params) => {
  return await Vue.prototype.$axios.get(url, { params })
}
export const getRealtime = async () => {
  return await get(REALTIME)
  // return await get(TEST_REALTIME)
}
export const getTestRealtime = async () => {
  return await get(TEST_REALTIME)
  // return await get(REALTIME)
}
